import { render, staticRenderFns } from "./ChooseTextarea.vue?vue&type=template&id=7e353e06&"
import script from "./ChooseTextarea.vue?vue&type=script&lang=js&"
export * from "./ChooseTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports